<p-tabs [(value)]="activeIndex" scrollable class="dark:text-gray-300">
    <p-tablist class="dark:text-gray-300">
        <p-tab [value]="0" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-history' | translate }}">
                <i
                    class="fa fa-history fa-lg dark:text-gray-300 dark:hover:text-white"
                    (click)="refreshHistory()"
                    [@rubberBand]="animateHistoryIcon"
                    (@rubberBand.done)="animateHistoryIcon = false"
                ></i>
            </span>
        </p-tab>
        <p-tab [value]="1" [disabled]="!addressId" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-phone' | translate }}"
                ><i class="fa fa-phone fa-lg dark:text-gray-300 dark:hover:text-white"></i
            ></span>
        </p-tab>
        <p-tab [value]="2" [disabled]="true" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-meeting' | translate }}"
                ><i class="fa fa-users fa-lg dark:text-gray-300"></i
            ></span>
        </p-tab>
        <p-tab [value]="3" [disabled]="true" class="dark:hover:bg-gray-800">
            <span
                class="dark:text-gray-300"
                pTooltip="{{ 'crm.activity-time-tracking' | translate }}"
                ><i class="fa fa-clock fa-lg dark:text-gray-300"></i
            ></span>
        </p-tab>
        <p-tab [value]="4" [disabled]="true" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-milestone' | translate }}"
                ><i class="fa fa-flag fa-lg dark:text-gray-300"></i
            ></span>
        </p-tab>
        <p-tab [value]="5" [disabled]="true" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-food' | translate }}"
                ><i class="fa fa-pizza-slice fa-lg dark:text-gray-300"></i
            ></span>
        </p-tab>
        <p-tab [value]="6" [disabled]="true" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-poo' | translate }}"
                ><i class="fa fa-poo fa-lg dark:text-gray-300"></i
            ></span>
        </p-tab>
        <p-tab [value]="7" [disabled]="!addressId" class="dark:hover:bg-gray-800">
            <span class="dark:text-gray-300" pTooltip="{{ 'crm.activity-task' | translate }}"
                ><i class="fa fa-tasks fa-lg dark:text-gray-300 dark:hover:text-white"></i
            ></span>
        </p-tab>
    </p-tablist>

    <p-tabpanels class="">
        <p-tabpanel [value]="0" class="">
            <div class="w-full min-h-0 max-h-[min(50vh,28rem)] overflow-y-auto animate-fadein">
                @if (isLoading() && addressId) {
                    <div class="flex min-h-[8rem] items-center justify-center">
                        <p-progressSpinner class="dark:text-gray-300" />
                    </div>
                } @else {
                    @if (activityHistories().length == 0) {
                        <div class="!text-center text-slate-400 dark:text-gray-400 m-1">
                            <h3 class="dark:text-gray-300">
                                {{ 'activityStream.no-history' | translate }}
                            </h3>
                        </div>
                    } @else {
                        <div class="w-full animate-fadein px-1 py-1.5">
                            <p-timeline
                                [value]="activityHistories()"
                                align="left"
                                styleClass="w-full [&_.p-timeline-event]:mb-2.5 [&_.p-timeline-event:last-child]:mb-0 [&_.p-timeline-event:last-child_.p-timeline-event-connector]:hidden [&_.p-timeline-event]:w-full [&_.p-timeline-event]:pl-0 [&_.p-timeline-event-separator]:mr-2.5 [&_.p-timeline-event-connector]:bg-slate-200 dark:[&_.p-timeline-event-connector]:bg-gray-700 [&_.p-timeline-event-content]:w-full [&_.p-timeline-event-content]:ml-0 [&_.p-timeline-event-content]:pb-0 [&_.p-timeline-event-opposite]:hidden [&_.p-timeline-event-marker]:top-2.5 [&_.p-timeline-event-marker]:translate-y-0"
                            >
                                <ng-template pTemplate="marker" let-event>
                                    <span
                                        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-500 text-xs text-white shadow-sm ring-2 ring-blue-100 dark:bg-blue-600 dark:ring-blue-900/40"
                                    >
                                        <i class="fa fa-phone text-[11px]" aria-hidden="true"></i>
                                    </span>
                                </ng-template>
                                <ng-template pTemplate="content" let-event>
                                    <article
                                        class="group relative w-full rounded-lg border border-slate-200/80 bg-white px-2.5 py-2 shadow-sm transition-colors hover:border-slate-300 dark:border-gray-700 dark:bg-gray-800/60 dark:hover:border-gray-600"
                                    >
                                        <button
                                            type="button"
                                            class="absolute right-1.5 top-1.5 z-10 rounded p-1 text-slate-400 opacity-0 transition-all hover:bg-red-50 hover:text-red-600 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400 group-hover:opacity-100 dark:hover:bg-red-950/40 dark:hover:text-red-400"
                                            (click)="event.delete()"
                                            pTooltip="{{ 'common.delete' | translate }}"
                                        >
                                            <i class="fa fa-trash text-xs" aria-hidden="true"></i>
                                        </button>

                                        <h3
                                            class="pr-7 text-sm font-semibold leading-snug text-slate-900 dark:text-white"
                                        >
                                            {{ event.description }}
                                        </h3>

                                        <div
                                            class="mt-1 flex flex-wrap items-center gap-1.5 text-xs text-slate-500 dark:text-gray-400"
                                        >
                                            <span
                                                class="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 dark:bg-gray-700/70"
                                            >
                                                <i
                                                    class="fa fa-calendar text-[10px] text-blue-500 dark:text-blue-400"
                                                    aria-hidden="true"
                                                ></i>
                                                <span>{{ event.startDateTime | localeDate: 'medium' }}</span>
                                                @if (event.endDateTime) {
                                                    <span class="text-slate-300 dark:text-gray-600">·</span>
                                                    <span>{{ event.endDateTime | localeDate: 'mediumTime' }}</span>
                                                }
                                            </span>
                                            @if (event.durationSeconds) {
                                                <span
                                                    class="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300"
                                                    [pTooltip]="'common.time' | translate"
                                                >
                                                    <i
                                                        class="fa fa-hourglass-half text-[10px]"
                                                        aria-hidden="true"
                                                    ></i>
                                                    {{ event.durationSeconds | s2h }}
                                                </span>
                                            }
                                            @if (event.employee?.name || event.employee?.lastName) {
                                                <span
                                                    class="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 dark:bg-gray-700/70"
                                                >
                                                    <i
                                                        class="fa fa-user text-[10px] text-slate-400"
                                                        aria-hidden="true"
                                                    ></i>
                                                    {{ event.employee.name }}
                                                    {{ event.employee.lastName }}
                                                </span>
                                            }
                                        </div>

                                        @if (event.notes) {
                                            <div
                                                class="mt-2 flex items-start gap-2 rounded-md border border-slate-100 bg-slate-50 px-2.5 py-2 dark:border-gray-700 dark:bg-gray-900/40"
                                            >
                                                <i
                                                    class="fa fa-sticky-note mt-0.5 shrink-0 text-[11px] text-slate-400 dark:text-gray-500"
                                                    [pTooltip]="'timeline.notes' | translate"
                                                    aria-hidden="true"
                                                ></i>
                                                <p
                                                    #notesText
                                                    class="min-w-0 flex-1 max-w-full overflow-hidden text-xs leading-normal text-slate-700 line-clamp-3 dark:text-gray-300"
                                                    [class.cursor-pointer]="isTextTruncated(notesText)"
                                                    [class.hover:text-blue-600]="isTextTruncated(notesText)"
                                                    [class.dark:hover:text-blue-400]="
                                                        isTextTruncated(notesText)
                                                    "
                                                    (click)="
                                                        isTextTruncated(notesText) &&
                                                            showNotesDialog(event.notes)
                                                    "
                                                >
                                                    {{ event.notes }}
                                                </p>
                                            </div>
                                        }
                                    </article>
                                </ng-template>
                            </p-timeline>
                        </div>
                    }
                }
            </div>
        </p-tabpanel>

        <p-tabpanel [value]="1" class="">
            <div class="flex flex-wrap">
                <!-- Description input -->
                <input
                    class="w-full px-3 py-2 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:text-gray-300 dark:placeholder-gray-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-colors duration-200"
                    pInputText
                    placeholder="{{ 'common.description' | translate }}"
                    [(ngModel)]="call.description"
                />

                <hr class="w-full my-2 border-t border-gray-200 opacity-20" />

                <div class="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Date section -->
                    <div class="flex flex-col">
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            {{ 'common.date' | translate }}
                        </label>
                        <div class="flex-1">
                            <p-datepicker
                                styleClass="w-full dark:text-gray-300 "
                                [(ngModel)]="call.startDateTime"
                                [showButtonBar]="true"
                                placeholder="{{ 'common.choose-date' | translate }}"
                            />
                        </div>
                        <div class="flex justify-center w-full mt-2">
                            <p-button
                                severity="secondary"
                                styleClass="w-full dark:text-gray-300"
                                (onClick)="dateToday()"
                                icon="fa fa-calendar"
                                label="{{ 'common.today' | translate }}"
                                size="small"
                            ></p-button>
                        </div>
                    </div>

                    <!-- Start time section -->
                    <div class="flex flex-col">
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            {{ 'common.start-time' | translate }}
                        </label>
                        <div class="flex-1">
                            <p-datepicker
                                styleClass="w-full dark:text-gray-300 "
                                [(ngModel)]="call.startDateTime"
                                placeholder="{{ 'common.choose-time' | translate }}"
                                [timeOnly]="true"
                                [inline]="false"
                            />
                        </div>
                        <div class="flex justify-center items-center w-full gap-2 mt-2">
                            <p-button
                                *ngIf="lastCallDateTime"
                                styleClass="flex items-center justify-center w-12 dark:text-gray-300"
                                pTooltip="{{ 'crm.time-of-last-call' | translate }}"
                                (click)="useLastCallTimeAsStartTime()"
                                size="small"
                                severity="secondary"
                                text="true"
                            >
                                <i
                                    [@bounce]="animateLastCall"
                                    (@bounce.done)="animateLastCall = false"
                                    class="fa fa-phone dark:text-gray-300"
                                ></i>
                            </p-button>
                            <p-button
                                styleClass="flex-1 dark:text-gray-300"
                                (click)="startTimeNow()"
                                icon="fa fa-clock"
                                severity="secondary"
                                label="{{ 'common.now' | translate }}"
                                size="small"
                            ></p-button>
                        </div>
                    </div>

                    <!-- End time section -->
                    <div class="flex flex-col">
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            {{ 'common.end-time' | translate }}
                        </label>
                        <div class="flex-1">
                            <p-datepicker
                                styleClass="w-full dark:text-gray-300 "
                                [(ngModel)]="call.endDateTime"
                                placeholder="{{ 'common.choose-time' | translate }}"
                                [timeOnly]="true"
                                [inline]="false"
                            />
                        </div>
                        <div class="flex justify-center w-full mt-2">
                            <p-button
                                styleClass="w-full dark:text-gray-300"
                                (click)="endTimeNow()"
                                icon="fa fa-clock"
                                severity="secondary"
                                label="{{ 'common.now' | translate }}"
                                size="small"
                            ></p-button>
                        </div>
                    </div>
                </div>

                <hr class="w-full my-2 border-t border-gray-200 opacity-20" />

                <!-- Notes textarea -->
                <textarea
                    class="w-full mt-2 px-3 py-2 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:text-gray-300 dark:placeholder-gray-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-colors duration-200"
                    pTextarea
                    [(ngModel)]="call.notes"
                    rows="2"
                    placeholder="{{ 'common.notes' | translate }}"
                ></textarea>

                <!-- Add activity button -->
                <p-button
                    class="w-full mt-4"
                    [loading]="addCallLoading"
                    [outlined]="true"
                    styleClass="w-full dark:text-gray-300  hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                    (onClick)="addCallActivity()"
                    label="{{ 'crm.add-activity' | translate }}"
                ></p-button>
            </div>
        </p-tabpanel>

        <p-tabpanel [value]="7" class="">
            <app-tasks-widget
                [tasks]="addressTasks"
                [attachedEntityType]="taskAttachedEntityType"
                [attachedEntityId]="addressId"
                [compact]="true"
                (tasksChange)="onAddressTasksChange($event)"
            />
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
